import { NgModule } from '@angular/core';
import { ImageRotatorComponent } from './image-rotator.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
  ],
  declarations: [ImageRotatorComponent],
  providers: [],
  exports: [ImageRotatorComponent],
})
export class ImageRotatorModule {
}
